// MobileMenu.tsx
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// import { images } from '@constants/images';
import { FiLogOut } from 'react-icons/fi';
import { dispatch } from '@store/index';
import { resetStep } from '@store/slices/login.slice';

interface Props {
  onClose: () => void;
  loungeId: string;
}

const MobileMenu: FC<Props> = ({ onClose, loungeId }) => {
  const { t: translate } = useTranslation();
  const navigate = useNavigate();

  const handleSignOut = () => {
    dispatch(resetStep());
    navigate('/login/phone');
  };

  return (
    <div className="fixed inset-0 z-50 flex flex-col bg-white pb-32">
      {/* Header */}
      <div className="flex items-center justify-between border-b bg-primary-100 p-4">
        <div className="flex items-center gap-3 p-3">
          {/* <img
            src={images?.city}
            alt="User"
            className="h-12 w-12 rounded-full"
          />
          <div>
            <p className="text-base font-semibold">John Doe</p>
            <p className="text-sm text-gray-500">+91 987654321</p>
          </div> */}
        </div>
        <button onClick={onClose}>
          <span className="text-2xl font-bold">×</span>
        </button>
      </div>

      {/* Navigation */}
      <div className="flex-1 overflow-y-auto text-sm font-semibold">
        <ul className="divide-y">
          <li>
            <button
              type="button"
              onClick={() => {
                navigate('/select-city');
                onClose();
              }}
              className="w-full p-4 text-left focus:outline-none"
            >
              Book a Lounge
            </button>
          </li>
          <li>
            <button
              type="button"
              onClick={() => {
                navigate('/my-bookings');
                onClose();
              }}
              className="w-full p-4 text-left focus:outline-none"
            >
              My Bookings
            </button>
          </li>
          <li>
            <button
              type="button"
              onClick={() => {
                navigate(`/terms-conditions?loungeId=${loungeId}`);
                onClose();
              }}
              className="w-full p-4 text-left focus:outline-none"
            >
              {translate('termsConditionsPage.heading')}
            </button>
          </li>
          {/* <li className="p-4">080 International Lounge, Mumbai</li> */}
        </ul>
      </div>

      {/* Sticky Footer */}
      <div className="fixed bottom-0 left-0 z-10 w-full border-t bg-white p-4 shadow-lg">
        <button
          className="flex w-full items-center justify-center gap-2 rounded-lg bg-red-50 p-3 text-red-600"
          onClick={handleSignOut}
        >
          <span className="text-xl">
            <FiLogOut size={24} className="text-red-600" />
          </span>
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default MobileMenu;
